export const SystemVariableType = {
  APPLICATION_CATEGORY: 'applicationCategory',
  BUSINESS_UNIT: 'businessUnit',
  TEAM: 'team',
  SISIC: 'sisic',
  VENDOR_CATEGORY: 'vendorCategory',
  HS_CODE: 'hsCode',
}

export const MenuSubGroup = {
  EQUOTATION_END_CUSTOMER: 'eQuotationEndCustomer',
  EQUOTATION_TENANT: 'eQuotationTenant',
  EQUOTATION_PRODUCT: 'eQuotationProduct',
}

export const MENU_SUB_GROUP_NONE = 'none'

export const MENU_SUB_GROUP_LABELS = {
  [MenuSubGroup.EQUOTATION_END_CUSTOMER]: 'eQuotation - End Customer',
  [MenuSubGroup.EQUOTATION_TENANT]: 'eQuotation - Tenant',
  [MenuSubGroup.EQUOTATION_PRODUCT]: 'eQuotation - Product',
}

export const MENU_SUB_GROUP_OPTIONS = [
  { label: 'None', value: '' },
  ...Object.values(MenuSubGroup).map((value) => ({
    label: MENU_SUB_GROUP_LABELS[value],
    value,
  })),
]
